import { useCallback, useState } from "react";

import {
  getTaskActivityOrder,
  TaskActivityOrder,
  toggleTaskActivityOrder,
} from "../activityOrderPreference";

/**
 * Custom hook for managing task activity order preferences
 *
 * @returns An object containing:
 * - activityOrder: The current task activity ordering preference
 * - toggleOrder: Function to toggle between newest-first and oldest-first
 * - orderTooltip: Tooltip message to show based on current order state
 */
export function useTaskActivityOrder() {
  // Initialize state with the saved preference
  const [activityOrder, setActivityOrder] = useState<TaskActivityOrder>(
    getTaskActivityOrder()
  );

  // Toggle between order options
  const toggleOrder = useCallback(() => {
    const newOrder = toggleTaskActivityOrder();
    setActivityOrder(newOrder);
    return newOrder;
  }, []);

  // Generate tooltip text describing the current state
  const orderTooltip =
    activityOrder === "oldest-first" ? "Oldest first" : "Newest first";

  return {
    activityOrder,
    toggleOrder,
    orderTooltip,
  };
}
